(function (factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    factory();
  }
})(function () {
  // Same string value as ThemeEvents.variantUpdate in assets/events.js ('variant:update').
  // Not imported directly since events.js is an ES module and this file is loaded as a
  // plain deferred <script>, not type="module" -- see product-form.js/sticky-add-to-cart.js
  // for the canonical dispatch/listen pattern this mirrors.
  var VARIANT_UPDATE_EVENT = 'variant:update';

  function toDateOnly(dateStr) {
    var parts = dateStr.split('-').map(Number);
    return new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
  }

  function getCutoffDate(eventDateStr) {
    var eventDate = toDateOnly(eventDateStr);
    var cutoff = new Date(eventDate.getTime());
    cutoff.setUTCDate(cutoff.getUTCDate() - 1);
    return cutoff;
  }

  function isEventClosedForPreorder(eventDateStr, todayDateStr) {
    // Intentional fail-open: an Event metaobject entry saved with a blank/missing date
    // stays purchasable rather than blocking indefinitely. The placeholder "Select an
    // event" option can never reach this function (the DOM-wiring code below skips it
    // via `if (!option.value) return;`), so this branch only matters for a real event
    // entry whose date field was left blank -- a plausible content mistake now that
    // Abby/Chelsey self-manage event entries, not just a theoretical case.
    if (!eventDateStr) return false;
    var cutoff = getCutoffDate(eventDateStr);
    var today = toDateOnly(todayDateStr);
    return today.getTime() >= cutoff.getTime();
  }

  function initBundleEventCutoff(doc) {
    var select = doc.querySelector('[name="properties[Event Name]"]');
    if (!select || select.tagName !== 'SELECT') return;

    var todayDateStr = new Date().toISOString().slice(0, 10);
    var options = Array.prototype.slice.call(select.options);
    var anyOpen = false;

    options.forEach(function (option) {
      if (!option.value) return;
      var closed = isEventClosedForPreorder(option.dataset.date, todayDateStr);
      if (closed) {
        option.disabled = true;
        option.classList.add('event-option--closed');
        if (!option.dataset.originalText) {
          option.dataset.originalText = option.textContent;
        }
        option.textContent = option.dataset.originalText + ' (Pre-order closed)';
      } else {
        anyOpen = true;
      }
    });

    var formId = select.getAttribute('form');
    var form = formId ? doc.getElementById(formId) : select.closest('form');
    var addToCartBtn = form && form.querySelector('button[type="submit"][name="add"]');
    // The sticky Add to Cart bar (assets/sticky-add-to-cart.js) proxies clicks to the real
    // button via `this.#targetAddToCartButton.click()` -- a disabled real button silently
    // no-ops on that click, but the sticky bar's OWN button (ref="addToCartButton" inside
    // <sticky-add-to-cart>, class "sticky-add-to-cart__button") stays visually enabled
    // unless we disable it too. Scoped to the <sticky-add-to-cart> element specifically
    // because the real product form also has an element with ref="addToCartButton".
    var stickyAddToCartBtn = doc.querySelector('sticky-add-to-cart .sticky-add-to-cart__button');

    // A previous call (e.g. a prior variant:update re-run) may have already inserted the
    // all-closed message as select's next sibling. Look it up so we never insert a second
    // one, and so we can clean it up if an event that was closed is now open again.
    var existingMessage = select.parentElement
      ? select.parentElement.querySelector('.bundle-cutoff-message')
      : null;

    if (!anyOpen) {
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
      }
      if (stickyAddToCartBtn) {
        stickyAddToCartBtn.disabled = true;
      }
      if (!existingMessage) {
        var message = doc.createElement('p');
        message.className = 'bundle-cutoff-message';
        message.textContent = 'Pre-order closed for all upcoming events.';
        select.insertAdjacentElement('afterend', message);
      }
    } else if (existingMessage) {
      existingMessage.remove();
    }
  }

  function init() {
    initBundleEventCutoff(document);

    // Fix for: the theme's product-form.js morphs in server-fetched Add to Cart button
    // HTML on every variant change (ThemeEvents.variantUpdate / 'variant:update'), which
    // knows nothing about the cutoff and would silently re-enable a button that should
    // stay disabled. Re-run the cutoff logic whenever that event fires. Listened for on
    // the closest '.shopify-section, dialog, product-card', matching the exact scoping
    // pattern product-form.js/sticky-add-to-cart.js/product-price.js already use for this
    // same event.
    var select = document.querySelector('[name="properties[Event Name]"]');
    var scope = select && select.closest('.shopify-section, dialog, product-card');
    if (scope) {
      scope.addEventListener(VARIANT_UPDATE_EVENT, function () {
        initBundleEventCutoff(document);
      });
    }
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  return {
    toDateOnly: toDateOnly,
    getCutoffDate: getCutoffDate,
    isEventClosedForPreorder: isEventClosedForPreorder,
    initBundleEventCutoff: initBundleEventCutoff
  };
});
